var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:_vm.classes,attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.icon)?_c('span',{staticClass:"fa",class:`fa-${_vm.icon}`,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }